import CheckCircleIcon from "@mui/icons-material/CheckCircle";
export const transparentStyle = {
  backgroundColor: "transparent",
  boxShadow: "none",
  marginRight: "0",
  color: "#004F9E",
  fontWeight: "bold",
  fontSize: "12px",
};
export const LuggageTableCol = [
  {
    headerName: "Class Type",
    field: "ServiceTypeName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: false,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Luggage Type",
    field: "LuggageType",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Luggage Sub Type",
    field: "subType",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Unit/Kg",
    field: "unit",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Luggage Rate",
    field: "luggageRate",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'number', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Minimum Fare",
    field: "minFare",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'number', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Maximum Stages",
    field: "maxStage",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'number', dataFormatter: null, width: 25 },
  },
  {
    headerName: "Action",
    field: "Action",
    headerSx: { textAlign: "left", minWidth: "212px" },
    isShowView: false,
    showFilter: false,
  },
];
export const LuggageTableData = [
  {
    ServiceTypeName: "Type A",
    LuggageType: "Type X",
    subType: "Subtype 1",
    unit: "kg",
    luggageRate: 10.5,
    minFare: 20.0,
    maxStage: 5,
    Action: "edit/delete",
  },
  {
    ServiceTypeName: "Type B",
    LuggageType: "Type Y",
    subType: "Subtype 2",
    unit: "unit",
    luggageRate: 15.0,
    minFare: 25.0,
    maxStage: 7,
    Action: "edit/delete",
  },
  {
    ServiceTypeName: "Type C",
    LuggageType: "Type Z",
    subType: "Subtype 3",
    unit: "kg",
    luggageRate: 12.0,
    minFare: 18.0,
    maxStage: 6,
    Action: "edit/delete",
  },
  // Add more data as needed
];
export const TimeTableListCol = [
  {
    headerName: "Depot Name",
    field: "CompanyName",
    headerSx: { textAlign: "left", minWidth: "180px" },
    isShowView: false,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Schedule No",
    field: "ScheduleNo",
    headerSx: { textAlign: "left", minWidth: "100px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Start Place Name",
    field: "fromcityname",
    headerSx: { textAlign: "left", minWidth: "140px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "End Place Name",
    field: "tocityname",
    headerSx: { textAlign: "left", minWidth: "140px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Schedule Start Time",
    field: "ScheduleStart",
    headerSx: { textAlign: "left", minWidth: "140px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Via Place",
    field: "ViaPlaces",
    headerSx: { textAlign: "left", minWidth: "140px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Page Title",
    field: "PageTitle",
    headerSx: { textAlign: "left", minWidth: "80px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Description",
    field: "Desc",
    headerSx: { textAlign: "left", minWidth: "90px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "About Route",
    field: "abroute",
    headerSx: { textAlign: "left", minWidth: "90px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Route Url",
    field: "URL",
    headerSx: { textAlign: "left", minWidth: "90px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Action",
    field: "Action",
    headerSx: { textAlign: "left", minWidth: "118px" },
    isShowView: false,
    showFilter: false,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
];
export const TimeTableListData = [
  {
    ServiceTypeName: "Bengaluru 4(BNG4)",
    ScheduleNo: "123",
    StartPlaceName: "Bengaluru(BNG)",
    EndPlaceName: "Hyderabad(HYD)",
    ScheduleStartTime: "19:00",
    ViaPlace: "Kurnool",
    PageTitle: "Y",
    Description: "Y",
    AboutRoute: "Y",
    RouteUrl: "Y",
  },
  {
    ServiceTypeName: "Bengaluru 4(BNG4)",
    ScheduleNo: "456",
    StartPlaceName: "Bengaluru(BNG)",
    EndPlaceName: "Chennai(CHN)",
    ScheduleStartTime: "19:00",
    ViaPlace: "Chittoor",
    PageTitle: "Y",
    Description: "Y",
    AboutRoute: "Y",
    RouteUrl: "Y",
  },
  // Add more objects as needed
];
export const PenaltyTableCol = [
  {
    headerName: "Franchisee ID",
    field: "LoginID",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: false,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Full Name",
    field: "UserName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Bus Station Name",
    field: "BranchName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Penalty Type",
    field: "PaneltyName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Penalty Date",
    field: "CreatedDT",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Place",
    field: "CityName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Penalty Amount",
    field: "Amount",
    headerSx: { textAlign: "right", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'number', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Action",
    field: "Action",
    headerSx: { textAlign: "left", minWidth: "100px" },
    isShowView: false,
    showFilter: false,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
];
export const PenaltyTableColView = [
  {
    headerName: "Franchisee ID",
    field: "id",
    headerSx: { textAlign: "left", minWidth: "100px" },
    isShowView: false,
    showFilter: true,
  },
  {
    headerName: "Full Name",
    field: "name",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
  },
  {
    headerName: "Bus Station Name",
    field: "stationName",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
  },
  {
    headerName: "Penalty Type",
    field: "penalty",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
  },
  {
    headerName: "Penalty Date",
    field: "date",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
  },
  {
    headerName: "Place",
    field: "city",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
  },
  {
    headerName: "Penalty Amount",
    field: "penalyAmt",
    headerSx: { textAlign: "right", minWidth: "120px" },
    isShowView: true,
    showFilter: true,
  },

];
export const PenaltyTableData = [
  {
    id: 1,
    name: "John Doe",
    stationName: "Station A",
    penalty: "Late Arrival",
    penaltyAmt: 50.0,
  },
  {
    id: 2,
    name: "Jane Smith",
    stationName: "Station B",
    penalty: "Improper Parking",
    penaltyAmt: 75.0,
  },
  {
    id: 3,
    name: "Alice Johnson",
    stationName: "Station C",
    penalty: "Unauthorized Stop",
    penaltyAmt: 100.0,
  },
  // Add more data as needed
];
export const ManageOnlineTableCol = [
  {
    headerName: "Full Name",
    field: "name",
    headerSx: { textAlign: "left", minWidth: "200px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Contact Number",
    field: "mobile_no",
    headerSx: { textAlign: "left", minWidth: "100px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Email",
    field: "user_name",
    headerSx: { textAlign: "left", minWidth: "145px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 40 }
  },
  {
    headerName: "Active",
    field: "is_active",
    headerSx: { textAlign: "left", minWidth: "150px" },
    isShowView: true,
    showFilter: true,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
  {
    headerName: "Action",
    field: "Action",
    headerSx: { textAlign: "left", minWidth: "200px" },
    isShowView: false,
    showFilter: false,
    xlCol: { dataType: 'string', dataFormatter: null, width: 25 }
  },
];
export const ManageOnlineTableData = [
  {
    loginName: "krishnapandey@maventechlabs.com",
    name: "Krishna Pandey",
    contact: "9901123456",
    email: "krishnapandey@maventechlabs.com",
    status: "yes",
  },
  {
    loginName: "krishnapandey@maventechlabs.com",
    name: "Krishna Pandey",
    contact: "9901123456",
    email: "krishnapandey@maventechlabs.com",
    status: "yes",
  },
  {
    loginName: "krishnapandey@maventechlabs.com",
    name: "Krishna Pandey",
    contact: "9901123456",
    email: "krishnapandey@maventechlabs.com",
    status: "yes",
  },
  // Add more data as needed
];
export const displayPriorityList = [
  { id: 1, name: "High" },
  { id: 2, name: "Normal" }
]
export const SuccessSaveLuggageBooking = () => (
  <div className="successfulDialogWrap">
    <div className="icons">
      <CheckCircleIcon
        sx={{ width: "38px", height: "38px", color: "#3C763C" }}
      />
    </div>
    <div className="message">
      Luggage Booking <br />
      Saved Successfully
    </div>
  </div>
);


export const modificationTypeOptList = [
  { id: 0, name: 'Booking' },
  { id: 3, name: 'Prepond/Postpond' },
  { id: 16, name: 'Duplicate' },
  { id: 15, name: 'Modify' },

]